import React from 'react';
import { Icon } from '@iconify/react';
import './HomePage.css';

function ExchangeBanner() {
    return (
        <div className="home-exchange-banner" role="status">
            <div className="home-exchange-banner-inner">
                <Icon icon="simple-icons:binance" className="home-exchange-banner-icon" aria-hidden="true" />
                <p className="home-exchange-banner-text">
                    <strong>Binance only.</strong> Trading is currently supported on Binance (spot and futures).
                    Connect your Binance API keys in Settings to start automating.
                </p>
            </div>
        </div>
    );
}

export default ExchangeBanner;